import subscribersTabTemplate from '@/notifications/subscribers/layout/subscribersTabTemplate';

export default subscribersTabTemplate(
  ['datasets'],
  ({ datasets }, { isGuest }) => datasets.read && !isGuest,
  'dataset',
);
